$(function() {
  // init tooltips, click to show, active toggles
  $('[data-toggle="tooltip"]').avTooltip();
});